const PARAM_SITES_TO_ACTIVATE = "SITES_TO_ACTIVATE";

// Utility function to safely convert various input types to a number
const toNumber = (value) => {
    if (value === null || value === undefined) return 0;
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;
    if (typeof value === "string") {
        const parsed = Number(value.replace(/,/g, "").trim());
        return Number.isFinite(parsed) ? parsed : 0;
    }
    return 0;
}

// Retrieves a specific parameter from an entity's parameters array. 
// This could be a site group or the overall study plan.
// Returns the parameter object if found, or null if not found or if parameters is not an array.
const getSiteParam = (entity, parameterName) => {
    const parameters = Array.isArray(entity?.parameters) ? entity.parameters : [];
    return parameters.find((p) => p?.parameterName === parameterName) || null;
}

const getCountries = (studyPlan) =>
    Array.isArray(studyPlan?.countries) ? studyPlan.countries : [];

const sumSiteActivationBound = (countries, boundKey) =>
    countries.reduce((sum, country) => {
        const siteGroups = Array.isArray(country?.siteGroups) ? country.siteGroups : [];
        const groupSum = siteGroups.reduce((gSum, siteGroup) => {
            const param = getSiteParam(siteGroup, PARAM_SITES_TO_ACTIVATE);
            return gSum + toNumber(param?.[boundKey]);
        }, 0);
        return sum + groupSum;
    }, 0);

const getTotalSitesRequired = (studyPlan) => {
    const overallParam = getSiteParam(studyPlan, PARAM_SITES_TO_ACTIVATE);
    return toNumber(overallParam?.lowerBound);
};

export const calculateSiteActivationStats = (studyPlan) => {
    if (studyPlan?.studyPlanType === 2) {
        return calculateForDurationPlans(studyPlan);
    } else if (studyPlan?.studyPlanType === 1) {
        return calculateForRatesPlans(studyPlan);
    }
    return getDefaultStats(studyPlan?.studyPlanType);
};

const calculateForDurationPlans = (studyPlan) => {
    const countries = getCountries(studyPlan);

    return {
        sitesActivated: sumSiteActivationBound(countries, "lowerBound"),
        totalSitesRequired: getTotalSitesRequired(studyPlan),
    };
}

const calculateForRatesPlans = (studyPlan) => {
    const countries = getCountries(studyPlan);

    return {
        sitesActivatedLowerBound: sumSiteActivationBound(countries, "lowerBound"),
        sitesActivatedUpperBound: sumSiteActivationBound(countries, "upperBound"),
        totalSitesRequired: getTotalSitesRequired(studyPlan),
    };
}

export const getDefaultStats = (studyPlanType) => { 
    if (studyPlanType === 1) {
        return {
            sitesActivatedLowerBound: 0,
            sitesActivatedUpperBound: 0,
            totalSitesRequired: 0,
        }
    }
    else if (studyPlanType === 2) {
        
        return {
            sitesActivated: 0,
            totalSitesRequired: 0,
        }
    }
    return null;
};